import React from "react";

// Stylesheet
import "./RegisterPopup.css";


import { toast } from "react-hot-toast";

//aws config
import firebase from "./../../../../firebase";

function RegisterPopup(account) {
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [isSubmited, setSubmited] = React.useState(false);

  React.useEffect(() => {
    const wa = account.account;
    async function fetchData() {
      await firebase
        .firestore()
        .collection("UserDataModel")
        .where("walletAddress", "==", `${wa}`)
        .get()
        .then((querySnapshot) => {
          setOpen(querySnapshot.empty);
        })
        .catch((error) => {});
    }
    fetchData();
    if (!isSubmited) {
      register();
    }
  });

  const register = async (e) => {
    setSubmited(true);
    setLoader(true);
    await firebase
      .firestore()
      .collection("UserDataModel")
      .where(
        "username",
        "==",
        `unnamed_${account.account.slice(account.account.length - 5)}`
      )
      .get()
      .then(async (querySnapshot) => {
        console.log(querySnapshot.empty);
        if (querySnapshot.empty) {
          await firebase
            .firestore()
            .collection("UserDataModel")
            .doc(account.account)
            .set(
              {
                username: `unnamed_${account.account.slice(
                  account.account.length - 5
                )}`,
                walletAddress: account.account,
                name: "no_name",
                email: "no_email",
                likedNft: [],
              },
              { merge: true }
            )
            .then(() => {
              setLoader(false);
              toast.success("Registered successfully!");
            })
            .catch((error) => {
              setLoader(false);
              toast.error(error.message);
            });
        } else {
          setLoader(false);
          toast.error("Username already exists!");
        }
      })
      .catch((error) => {});
  };
  return null;
}

export default RegisterPopup;
